import { Attributes, NeoModel, Rules, Validation, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class CheckQuerySummaryLookup extends ValueObject {
    
    public staticServiceProviderHouseCheckQueryId: number = 0;

    public checkQueryId: number = 0;

    @Rules.Required()
    @Attributes.Display("Service Provider Grouping Name")
    public staticServiceProviderFileGroupingId: number = 0;

    @Rules.Required("Please select a check query")
    public checkQueryName: string = "";

    public type: string = "";

    @Rules.Required("Please select a broker")
    public serviceProviderGroupingName: string = "";

    public runForStaticServiceProviderInd: boolean = false;

    public activeInd: boolean = false;

    @Rules.Required()
    @Rules.StringLength(500)
    @Attributes.Display("Data Report Description")
    public checkQueryDescription: string | null = "";

    public proceedsProcess: string | null = null;

    public importProcessStepId: number = 0;

    public runFrequency: number | null = null;

    public lastExecutionDateString: string | null = null;

    public nextExecutionDateString: string | null = null;

    @Attributes.Date()
    public nextExecutionDateTime: Date | null = null;

    public dataTableIsInBodyInd: boolean = false;

    public emailAddresses: string = "";

    public emailAddressesList: string[] = [];

    public triggerNextExecutionDate: boolean = false;

    public addResultInd: boolean = false;

    @Attributes.Decimal()
    public minVariance: number = 0;

    @Attributes.Decimal()
    public maxVariance: number = 0;

    protected addBusinessRules(rules: Validation.Rules<this>) 
    {
        super.addBusinessRules(rules);

        rules.failWhen(x => this.areAnyEmailsEmpty(x.emailAddressesList), "Please ensure all email fields have values");
        rules.failWhen(x => (Number)(x.maxVariance).compareLT((Number)(x.minVariance)), "Max variance must be larger than min variance.");
        rules.failWhen(x => (x.importProcessStepId === 0 || x.importProcessStepId === null) && (x.runFrequency === null || x.runFrequency===0), "Please select an import process or specify a run frequency.")
            .onProperties(c => [c.importProcessStepId, c.runFrequency])
    }

    private areAnyEmailsEmpty(input: string[])
    {
        var indicator = false;
        input.forEach(x => 
        {
            if(x === null || x === "")
            {
                indicator = true;
            }
        });
        return indicator;
    } 
}